import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {ChangeDetectionStrategy,ChangeDetectorRef,Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiParseLinks} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {BehaviorSubject,Observable,forkJoin} from 'rxjs';
import 'rxjs/add/observable/fromPromise';
import {Principal,StateStorageService} from 'src/app/core';
import {ConfirmationModelService} from 'src/app/shared/confirmation-modal/confirmation-model.service';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {OrderPipe} from 'src/app/shared/custom-pipe/order.pipe';
import {FutureDataType} from 'src/app/shared/model/future_data_type.model';
import {IRuleMySuffix} from 'src/app/shared/model/rule-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {environment} from 'src/environments/environment';
import {RuleMySuffixService} from '../rule-my-suffix/rule-my-suffix.service';
import {StorageRuleMySuffixService} from '../storage-rule-my-suffix/storage-rule-my-suffix.service';
import {ScopeMySuffixService} from './scope-my-suffix.service';
import { CommonUtils } from 'src/app/shared/util/common-utils';
import { RoleUtil } from 'src/app/shared/util/role-util';
import { TdisConstants } from 'src/app/shared/constants/tdis-constants';
declare let $: any;

@Component({
    selector: 'jhi-scope-my-suffix-detail',
    templateUrl: './scope-my-suffix-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers:[OrderPipe]

})
export class ScopeMySuffixDetailComponent implements OnInit  {
    
    @ViewChild('confirmDelete') confirmDelete: ModalDirective;
    @ViewChild('draftRelationModal') draftRelationModal: ModalDirective;
    @ViewChild('ruleDraftRelationModal') ruleDraftRelationModal: ModalDirective;
    @ViewChild('scopeCertificateViewModal') scopeCertificateViewModal: ModalDirective;
    @ViewChild('ruleViewModal') ruleViewModal: ModalDirective;
    @ViewChild('storageRuleViewModal') storageRuleViewModal: ModalDirective;
    @ViewChild('confirmForSummaryPageModal') confirmForSummaryPageModal: ModalDirective;

    readonly RoleUtil = RoleUtil;
    readonly TdisConstants = TdisConstants;

    
    
    scopePreviewString: string = "";
    scope: any;
    rules = [];
    orderBySequence="sequence"
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    deleteRule: IRuleMySuffix;
    storageRule = [];
    //deleteRuleIndex: number;
    deleteRuleId:number

    isclauseDeductableCollapsed = true;
    isExtensionDeductableCollapsed = true;

    clauseDeductable = [];
    extensionDeductable = [];
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    isSelectedRuleActive: boolean = true;
    navigableScopeID: any;
    navigableRuleID: any;
    extensionCheckItemCount: number;
    extensionFinalArray: any[];
    extensionRateDescFinalArray: any[];
    clauseRateListFinalArray: any[];
    openRequest :  boolean = false;
    ruleView = null;
    show: any;
    ruleViewKeys=[];
    
    isAcoountingDisable: boolean;
    isPremiumCalculationDisable: boolean;
    isComplete=new BehaviorSubject<boolean>(false);

    selectedClient=environment.login;

    editPermission: boolean = false;
    
    constructor(
        private ruleService: RuleMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private storageRuleMySuffixService: StorageRuleMySuffixService,
        private scopeMySuffixService: ScopeMySuffixService,
        private futureRecordService: ConfirmationModelService,
        private cd: ChangeDetectorRef,
        private orderPipe: OrderPipe,
        private languageChangeService:LanguageChangeService,
        private stateStorageService: StateStorageService,

    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
        });
          this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size')
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                  window.history.back();
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    clauseNames: any = '';
    tempScope = [];
    summaryDetailsUrl: string = '';
    otsKeyword: string = '';
    isOts: boolean = false;

    randomOtsId=null;

    ngOnInit() {
        const CURRENT_URL: string = this.router.url;
        this.isOts = CURRENT_URL.includes('ots');
        const isSummaryDetailsUrl: string = localStorage.getItem(MessageConst.CURRENT_URL_SUMMARY_PAGE);
        if(this.isOts && isSummaryDetailsUrl) {
            this.summaryDetailsUrl = JSON.parse(isSummaryDetailsUrl);
            this.otsKeyword = 'ots';
        }

        
        this.randomOtsId = this.activatedRoute.snapshot.queryParams[ "ranOtsId" ];

        if(CommonUtils.isNotNil(this.randomOtsId) && this.stateStorageService.contains(this.randomOtsId)) {
            this.summaryDetailsUrl=this.stateStorageService.getCurrentSummaryPageUrl(this.randomOtsId);
            this.isOts=true;
            this.otsKeyword = 'ots';
        }


        this.principal.setTitle("Scopes");
        // this.checkAccountingPermission();
        // this.checkPremiumCalculationPermission();

        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        let allApi = []
        let checkAccounting:Observable<any> =Observable.fromPromise(this.principal.checkAccountingAccessForUser());
        let checkPermission:Observable<any> =Observable.fromPromise(this.principal.checkPremiumCalculationAccessForUser());
        let data=this.activatedRoute.data;

        allApi.push(checkAccounting);
        allApi.push(checkPermission);
        
        data.subscribe(( res ) => {
            let payload = res.scope;
            
            if(res.pageTitle =="OpenScopes"){
                console.log("open scope")
                // this.editPermission = JSON.parse(localStorage.getItem("allowBrokerForManualRequests"))
                // console.log(this.editPermission)
                this.openRequest = true;
            }

            this.editPermission = JSON.parse(localStorage.getItem("allowBrokerForManualRequests"))
            console.log(this.editPermission)

            if(this.editPermission){
                this.openRequest = false;
                console.log(this.openRequest, this.editPermission, "if block")
            }else{
                localStorage.removeItem("allowBrokerForManualRequests")
            }
            
            this.scope = payload.body;
            this.rules=this.scope.rules;
            this.storageRule = this.scope.storageRules;
            this.scope.clauseDeductables = this.scope.clauseDeductable;
            this.scope.extensionDeductables = this.scope.extensionDeductable;
            this.tempScope = this.scope.clauseDeductable;
            this.sortRulesBasedOnLastUpdate();
            this.sortStorageRulesBasedOnLastUpdate();
           
            this.isComplete.next(true);

        });

        forkJoin(allApi).subscribe(allRes => {
            this.isComplete.subscribe(re => {
              if(re==true)  
                this.checkAccountingPermission(allRes[0]);
                this.checkPremiumCalculationPermission(allRes[1]);
            })

        })

    }

    loadScope() {
        this.scopeMySuffixService.findForViewScope(this.scope.id).subscribe(res => {
            let scopeView = res.body;
            this.scope = scopeView;
            this.rules = scopeView.rules;
            this.storageRule = scopeView.storageRules;
            this.scope.clauseDeductables = scopeView.clauseDeductable;
            this.scope.extensionDeductables = scopeView.extensionDeductable;
            this.tempScope = scopeView.clauseDeductable;
        }, err => {

        })
    }


    //clauses and extensions names return method
    clauseNamesFuncton(data) {
        // console.log(data);

        let str = '';
        if (data) {
            let addComma = "";
            data.clauseExtensionList.map((element, index) => {
                if (data.clauseExtensionList.length - 1 == index) {
                    addComma = ""
                } else {
                    addComma = ","
                }
                str += (element.name + addComma)
            })
            return str;
        }
        // console.log(str);

    }


    loadAll() {
        this.ruleService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<IRuleMySuffix[]>) => this.paginateRules(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    private paginateRules(data: IRuleMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.rules = data;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    transition() {
        this.router.navigate(['/rule-my-suffix'], {
            queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    }

    previousState() {
        if(this.scope&&this.scope.policyId) {
            this.router.navigate(['policy/'+this.scope.policyId+'/view']);
        } else {
            let pid=Number(localStorage.getItem('policyId'));
            this.router.navigate(['policy/'+pid+'/view']);
        }
    }


    removeRule(index, rule) {

        this.deleteRuleId = rule.id;
        this.deleteRule = rule;
        if (rule.activeStatus == TdisConstants.ActiveStatus.IN_ACTIVE) {
            this.isSelectedRuleActive = false;
        } else {
            this.isSelectedRuleActive = true;
        }
        this.confirmDelete.show();
    }

    futureStatus: boolean = false;
    isConfirmed: boolean = false;
    setFutureStatus(futureStatus) {
        this.futureStatus = futureStatus;
        this.removeRuleDetails();
    }


    removeRuleDetails() {
        let deleteRuleIndex ;
        if (this.storageRule) {
            for (let index = 0; index < this.storageRule.length; index++) {
                const element = this.storageRule[index];
                if(element['id'] == this.deleteRuleId){
                    deleteRuleIndex = index;
                    break;
                }
                
            }
                
            this.storageRuleMySuffixService.delete(this.deleteRule.id).subscribe(response => {
                let rule;
                this.isConfirmed = true;
                if (this.futureStatus) {
                    this.updateStorageRuleExistedFutureRecordStatus(this.deleteRule.id);
                }
                if (this.storageRule[deleteRuleIndex].activeStatus == TdisConstants.ActiveStatus.ACTIVE) {
                    this.storageRule[deleteRuleIndex].activeStatus = TdisConstants.ActiveStatus.IN_ACTIVE;
                    rule = this.storageRule[deleteRuleIndex];
                } else {
                    this.storageRule[deleteRuleIndex].activeStatus = TdisConstants.ActiveStatus.ACTIVE;
                    rule = this.storageRule[deleteRuleIndex];

                }
                // view of table is not updating that why we are written this line
                this.cd.detectChanges()
                this.hideConfirmDeleteModal();
                this.isConfirmed = false;
            });
        } else {

            for (let index = 0; index < this.rules.length; index++) {
                const element = this.rules[index];
                if(element['id'] == this.deleteRuleId){
                    deleteRuleIndex = index;
                    break;
                }
                
            }

            this.isConfirmed = true;
            if (this.futureStatus) {
                this.updateRuleExistedFutureRecordStatus(this.deleteRule.id);
            }
            if (this.rules[deleteRuleIndex].activeStatus == TdisConstants.ActiveStatus.ACTIVE) {
                this.rules[deleteRuleIndex].activeStatus = TdisConstants.ActiveStatus.IN_ACTIVE;
            } else {
                this.rules[deleteRuleIndex].activeStatus = TdisConstants.ActiveStatus.ACTIVE;
            }
            this.ruleService.delete(this.deleteRule.id).subscribe(response => {
                // this.rules[deleteRuleIndex] = response.body;
                // update response in the rules table 
                let responseData = response.body;
                // find the index
                let updatebleIndex = this.rules.findIndex(item => item.id == responseData.id);
                // update at the particular index
                if (updatebleIndex > -1) {
                    this.rules[updatebleIndex] = responseData;
                    this.rules = [...this.rules];
                }
                // view of table is not updating that why we are written this line
                this.cd.detectChanges()
                this.hideConfirmDeleteModal();
                this.isConfirmed = false;
                //    this.loadScope();

            });
        }

    }

    updateRuleExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.deleteRule.id,
            futureDataType: FutureDataType.RULE.valueOf(),
            fromEffectiveDateFormatted: this.deleteRule.fromEffectiveDate,
            masterStatus: this.deleteRule.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            // console.log(response.body);
        });
    }

    updateStorageRuleExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.deleteRule.id,
            futureDataType: FutureDataType.STORAGE_RULE.valueOf(),
            fromEffectiveDateFormatted: this.deleteRule.fromEffectiveDate,
            masterStatus: this.deleteRule.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            // console.log(response.body);
        });
    }

    changeStatus(rule, index) {
        if (rule[index].activeStatus == TdisConstants.ActiveStatus.ACTIVE) {
            rule[index].activeStatus = TdisConstants.ActiveStatus.IN_ACTIVE;
        } else {
            rule[index].activeStatus = TdisConstants.ActiveStatus.ACTIVE;
        }
    }

    hideConfirmDeleteModal() {
        this.deleteRule = null;
        this.deleteRuleId = null;

        this.confirmDelete.hide();
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewHistoryScope(scopeObj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Scope (' + scopeObj.name + ') History';
        this.historyType = "SCOPE_AUDIT";
        this.historyId = scopeObj.id;
    }

    viewHistoryRule(scopeObj, ruleObj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Rule (' + scopeObj.name + ') History';
        this.historyType = "RULE_AUDIT";
        this.historyId = ruleObj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');

    }

    viewHistoryStorageRule(scopeObj, ruleObj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Storage Rule (' + scopeObj.name + ') History';
        this.historyType = "STORAGE_RULE_AUDIT";
        this.historyId = ruleObj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }

    viewFutureHistoryScope(scopeObj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Scope (' + scopeObj.name + ') Future Records';
        this.historyType = "SCOPE_AUDIT";
        this.historyId = scopeObj.id;
    }


    viewFutureHistoryRule(scopeObj, ruleObj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Rule (' + scopeObj.name + ') Future Records';
        this.historyType = "RULE_AUDIT";
        this.historyId = ruleObj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');

    }

    viewFutureHistoryStorageRule(scopeObj, ruleObj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Storage Rule (' + scopeObj.name + ') Future Records';
        this.historyType = "STORAGE_RULE_AUDIT";
        this.historyId = ruleObj.id;
        $('.dropdown.show .dropdown-toggle').dropdown('toggle');
    }


    trackByIndex(index, item: any) {
        return index;
    }
    checkRelationWithDraftRequest(inRelation, scopeID, ruleID, type,action?:string) {
        this.navigableScopeID = scopeID;
        this.navigableRuleID = ruleID
        if(action == 'CLONE'){
            localStorage.setItem('RULE_CLONE','CLONE')
        }
        if (inRelation) {
            if (type == "SCOPE") {
                this.draftRelationModal.show()
            } else {
                this.ruleDraftRelationModal.show()
            }

        } else {
            if (type == 'SCOPE' && !(this.otsKeyword && this.summaryDetailsUrl)) {
                this.router.navigate(['/scope-my-suffix', scopeID, 'edit'])
            } else if(type == 'SCOPE' && (this.otsKeyword && this.summaryDetailsUrl)) {
                this.router.navigate(['/scope-my-suffix', scopeID, 'edit', 'ots'],{queryParams:{ranOtsId:this.randomOtsId}});
            } else if(this.otsKeyword && this.summaryDetailsUrl) {
                this.router.navigate(['/rule-my-suffix',ruleID, scopeID, 'ots','edit'],{queryParams:{ranOtsId:this.randomOtsId}});
            } else {
                this.router.navigate(['/rule-my-suffix', ruleID, scopeID, 'edit'])
                // ['/rule-my-suffix', rule.id, scope.id, 'edit']
            }
        }

    }
    // ruleCheckRelationWithDraftRequest(inRelation,scopeId,ruleId){
    //     this.navigableScopeID=scopeId;

    //     if(inRelation){
    //         this.draftRelationModal.show()
    //     }else{
    //         this.router.navigate(['/scope-my-suffix', id, 'edit'])
    //     }
    // }
    navigateScopeSuffix() {
        this.router.navigate(['/scope-my-suffix', this.navigableScopeID, 'edit'])
    }
    navigateRuleSuffix() {
        this.router.navigate(['/rule-my-suffix', this.navigableRuleID, this.navigableScopeID, 'edit'])
    }
    hideRuleDraftRelationModal() {
        this.ruleDraftRelationModal.hide()
    }
    hideDraftRelationModal() {
        this.draftRelationModal.hide()
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }

    scopeCertificatePreview(){
        this.extensionCheckItemCount = 0;
        this.scope.extensionDeductables.map(el=>{
            el.clauseExtensionList.map(item=>{
                item['checked']=true;
                this.extensionCheckItemCount = this.extensionCheckItemCount + 1;
            })
        })
        this.getClauseExtensionDescription()
        this.scopeCertificateViewModal.show();
    }
    hidescopeCertificateViewModal(){
        this.scopeCertificateViewModal.hide();
    }
    onCategoryExtensionsSelect(event, extensionIndex, extensionDescriptionIndex) {
        if (event.target.checked) {
            this.scope.extensionDeductables[extensionIndex].clauseExtensionList[extensionDescriptionIndex]['checked'] = true
        } else {
            this.scope.extensionDeductables[extensionIndex].clauseExtensionList[extensionDescriptionIndex]['checked'] = false
        }
        this.scope.extensionDeductables=[...this.scope.extensionDeductables];
        // this.extensionCheckItemCount = 0;
        // this.scope.extensionDeductables.map(el => {
        //     el.clauseExtensionList.map(item => {
        //         if (item['checked']) {
        //             this.extensionCheckItemCount = this.extensionCheckItemCount + 1;
        //         }

        //     })
        // })
        this.getClauseExtensionDescription();
    }
    getClauseExtensionDescription(){
        this.scope.scopeClauseSequenceInfos=this.orderPipe.transform(this.scope.scopeClauseSequenceInfos,this.orderBySequence);
        
         this.extensionFinalArray=[];
         this.extensionRateDescFinalArray=[];
         this.clauseRateListFinalArray=[];
         this.scope.clauseDeductable.map(clause=>{
             clause.deductableRateList.map(clauseDesc=>{
                if(clauseDesc.printEnable && clauseDesc.decuctableDescription){
                    this.clauseRateListFinalArray.push(clauseDesc)
                }
             })
         })
        this.scope.extensionDeductable.map(extension=>{
            let selectedExtensionDeductableExtension = 0;
            // if the extension with deductable , extensions with at least one is selected we need show the extension deductable
            extension.clauseExtensionList.map(extDesc=>{
                if(extDesc.checked){
                    this.extensionFinalArray.push(extDesc)
                    selectedExtensionDeductableExtension = selectedExtensionDeductableExtension + 1
                }
            })
            if(selectedExtensionDeductableExtension>0){
                extension.deductableRateList.map(desc=>{
                    if(desc.printEnable && desc.decuctableDescription){
                        this.extensionRateDescFinalArray.push(desc)
                    }
                })
            }
            
        })
        this.scopePreviewString = '';
        console.log(this.extensionFinalArray,"extensionFinalArray");
        console.log(this.extensionRateDescFinalArray,"extensionRateDescFinalArray");
        console.log(this.clauseRateListFinalArray,"clauseRateListFinalArray");
        if(this.scope.product == TdisConstants.Product.SELLERS_INTEREST){
            this.scopePreviewString ='Seller\'s Interest ';
        }else if(this.scope.product == TdisConstants.Product.BUYERS_INTEREST){
            this.scopePreviewString ='Buyer\'s Interest ';
        }
        this.scope.scopeClauseSequenceInfos.map((clauses, index) => {
            this.scopePreviewString += clauses.clauseExtension.clauseDescrition + ((index == this.scope.scopeClauseSequenceInfos.length - 1) ? '; ' : ', ');
        })
        this.clauseRateListFinalArray.forEach((clauseDeductable, index) => {
            if(clauseDeductable.decuctableDescription){
                this.scopePreviewString += clauseDeductable.decuctableDescription + ((index == this.clauseRateListFinalArray.length - 1) ? '; ' : ', ');
            }
        })
        this.extensionFinalArray.forEach((extension, index) => {
            if(extension.extensionDescription){
                this.scopePreviewString += extension.extensionDescription + ((index == this.extensionFinalArray.length - 1) ? '; ' : ', ');
            }
        });
        this.extensionRateDescFinalArray.forEach((extensionDeductable, index) => {
            if(extensionDeductable.decuctableDescription){
                this.scopePreviewString += extensionDeductable.decuctableDescription + ((index == this.extensionRateDescFinalArray.length - 1) ? '; ' : ', ');
            }
        })
        // console.log(this.scopePreviewString, "this.scopePreviewString");
        this.scopePreviewString = this.scopePreviewString.replace(/;([^;]*)$/, '.');
    }


    getRule(id , show){
        this.show =show;
        let url ;
        if(show =='Cargo'){
            url = "/cargos"
        }else if(show =='Loading And Packing Type'){
            url = "/loading-packing"
        }else if(show == 'From Country'){
            url = "/from-country"
        }else if(show == 'To Country'){
            url = "/to-country";
        }
      
            this.ruleService.findRuleData(id,url ,'NORMAL' ).subscribe(res =>{
                this.ruleView = null;
                this.ruleView = JSON.parse(JSON.stringify(res.body));
                console.log(this.ruleView);
                
            if(this.ruleView){
                this.cd.detectChanges()
                this.ruleViewModalShow();
            }
            
            });
         
       
        
    }

    ruleViewModalShow(){
        this.ruleViewModal.show();


    }
    ruleViewModalHide(){
        this.ruleViewModal.hide();
    }

    storageRuleViewModalShow(){
        this.storageRuleViewModal.show();


    }
    storageRuleViewModalHide(){
        this.storageRuleViewModal.hide();
    }

    getStorageRule(id , show){

        this.show =show;
        let url ;
        if(show =='Cargo'){
            url = "/cargos";
        }else if(show =='Packing Type'){
            url = "/packing-type";
        }

        this.ruleService.findRuleData(id,url, 'STORAGE' ).subscribe(res =>{
            this.ruleView = null;
            this.ruleView =  JSON.parse(JSON.stringify(res.body));
        if(this.ruleView){
            this.cd.detectChanges()
            this.storageRuleViewModalShow();
        }
        
        });

    }

    sortRulesBasedOnLastUpdate() {
        if(this.rules) {
            this.rules.sort(function(d1,d2): any {
                return Date.parse(d2.lastModifiedDate)-Date.parse(d1.lastModifiedDate);
            });
        }
    }
        
    sortStorageRulesBasedOnLastUpdate() {
        if(this.storageRule) {
            this.storageRule.sort(function(d1,d2): any {
                return Date.parse(d2.lastModifiedDate)-Date.parse(d1.lastModifiedDate);
            });
        }
    }

    // checkAccountingPermission(){
    //     this.principal.checkAccountingAccessForUser().then(res =>{
    //         if(res){
    //             console.log("checkAccountingAccessForUser if" , res);
    //             this.cd.detectChanges()
    //             this.isAcoountingDisable = false;
    //         }else{
    //             console.log("checkAccountingAccessForUser else" , res);
    //             this.cd.detectChanges()
    //             this.isAcoountingDisable =  true;
    //         }
    //     });
    // }
    
    checkAccountingPermission(res) {
        if(res) {
            console.log("checkAccountingAccessForUser if",res);
            this.isAcoountingDisable=false;
            this.cd.detectChanges()
        } else {
            console.log("checkAccountingAccessForUser else",res);
            this.isAcoountingDisable=true;
            this.cd.detectChanges()
        }
    }

    // checkPremiumCalculationPermission(){
    //     this.principal.checkPremiumCalculationAccessForUser().then(res =>{
    //         this.cd.detectChanges()

    //         if(res){
    //             this.cd.detectChanges()
    //             console.log("checkPremiumCalculationPermission if" , res);
    //             this.isPremiumCalculationDisable= false;
    //         }else{
    //             this.cd.detectChanges()
    //             console.log("checkPremiumCalculationPermission else" , res);
    //             this.isPremiumCalculationDisable= true;
    //         }
    //     });
    // }
    
    checkPremiumCalculationPermission(res) {
        // this.cd.detectChanges()
        if(res) {
            console.log("checkPremiumCalculationPermission if",res);
            this.isPremiumCalculationDisable=false;
            this.cd.detectChanges()
        } else {
            console.log("checkPremiumCalculationPermission else",res);
            this.isPremiumCalculationDisable=true;
            this.cd.detectChanges()
        }
    }
        

    getClauseName(type: string) {
     
        // return changeCase.capitalCase(type);
        return type;
      }

      showSummaryPageModal() {
        if(this.rules && this.rules.length > 0) {
            this.router.navigateByUrl(this.summaryDetailsUrl);
        } else {
            this.confirmForSummaryPageModal.show();
        }
      }

      hideSummaryPageModal() {
        this.confirmForSummaryPageModal.hide();
      }
    

}

